import { render, staticRenderFns } from "./product-img.vue?vue&type=template&id=ab571e00&scoped=true&"
import script from "./product-img.vue?vue&type=script&lang=js&"
export * from "./product-img.vue?vue&type=script&lang=js&"
import style0 from "./product-img.vue?vue&type=style&index=0&id=ab571e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab571e00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default})
